export const categories = [
  { id: "shopping", name: "购物电商", slug: "shopping", icon: "ri-shopping-bag-3-line", description: "正品购物平台，安心网购从这里开始" },
  { id: "news", name: "新闻资讯", slug: "news", icon: "ri-newspaper-line", description: "权威新闻媒体，获取最新资讯" },
  { id: "video", name: "视频娱乐", slug: "video", icon: "ri-film-line", description: "正版视频平台，畅享高清视听" },
  { id: "social", name: "社交平台", slug: "social", icon: "ri-chat-smile-2-line", description: "主流社交网络，连接你我他" },
  { id: "education", name: "学习教育", slug: "education", icon: "ri-book-open-line", description: "优质教育平台，知识触手可及" },
  { id: "finance", name: "金融理财", slug: "finance", icon: "ri-bank-line", description: "正规金融服务，财富管理更安心" },
  { id: "technology", name: "科技数码", slug: "technology", icon: "ri-computer-line", description: "前沿科技资讯，数码产品评测" },
  { id: "travel", name: "旅游出行", slug: "travel", icon: "ri-flight-takeoff-line", description: "出行服务平台，旅途更便捷" },
  { id: "life", name: "生活服务", slug: "life", icon: "ri-service-line", description: "便民生活服务，日常所需一应俱全" },
  { id: "government", name: "政府组织", slug: "government", icon: "ri-government-line", description: "官方政府网站，权威信息发布" },
];

export const websites = [
  // 购物电商
  { id: 1, name: "淘宝网", url: "https://www.taobao.com", description: "阿里巴巴旗下最大的零售电商平台，千万商品任你挑选", category: "shopping", tags: ["电商", "零售"] },
  { id: 2, name: "京东", url: "https://www.jd.com", description: "中国领先的自营式电商企业，正品保障，极速物流", category: "shopping", tags: ["电商", "自营"] },
  { id: 3, name: "拼多多", url: "https://www.pinduoduo.com", description: "新电商开创者，致力于将娱乐社交元素融入电商运营", category: "shopping", tags: ["电商", "拼团"] },
  { id: 4, name: "唯品会", url: "https://www.vip.com", description: "全球精选品牌特卖平台，正品保证，天天特价", category: "shopping", tags: ["电商", "特卖"] },
  { id: 5, name: "苏宁易购", url: "https://www.suning.com", description: "中国领先的O2O智慧零售商，线上线下融合发展", category: "shopping", tags: ["电商", "家电"] },
  { id: 6, name: "天猫", url: "https://www.tmall.com", description: "阿里巴巴旗下B2C购物平台，品牌旗舰店聚集地", category: "shopping", tags: ["电商", "品牌"] },
  // 新闻资讯
  { id: 7, name: "新华网", url: "https://www.xinhuanet.com", description: "中国国家通讯社主办的综合新闻信息服务门户网站", category: "news", tags: ["新闻", "官方"] },
  { id: 8, name: "人民网", url: "https://www.people.com.cn", description: "人民日报建设的以新闻为主的大型网上信息发布平台", category: "news", tags: ["新闻", "官方"] },
  { id: 9, name: "央视网", url: "https://www.cctv.com", description: "中央广播电视总台主办的中央重点新闻网站", category: "news", tags: ["新闻", "视频"] },
  { id: 10, name: "环球网", url: "https://www.huanqiu.com", description: "人民日报社主办的国际新闻资讯平台", category: "news", tags: ["新闻", "国际"] },
  { id: 11, name: "澎湃新闻", url: "https://www.thepaper.cn", description: "专注时政与思想的互联网新闻平台，深度原创报道", category: "news", tags: ["新闻", "原创"] },
  { id: 12, name: "中国新闻网", url: "https://www.chinanews.com.cn", description: "中国新闻社主办的国家级重点新闻网站", category: "news", tags: ["新闻", "综合"] },
  // 视频娱乐
  { id: 13, name: "哔哩哔哩", url: "https://www.bilibili.com", description: "中国领先的年轻人文化社区和视频平台", category: "video", tags: ["视频", "社区"] },
  { id: 14, name: "爱奇艺", url: "https://www.iqiyi.com", description: "中国高品质视频娱乐服务平台，海量正版影视资源", category: "video", tags: ["视频", "影视"] },
  { id: 15, name: "腾讯视频", url: "https://v.qq.com", description: "腾讯旗下综合视频平台，自制内容与版权内容并重", category: "video", tags: ["视频", "影视"] },
  { id: 16, name: "优酷", url: "https://www.youku.com", description: "阿里巴巴旗下视频平台，提供丰富多元的视频内容", category: "video", tags: ["视频", "影视"] },
  { id: 17, name: "抖音", url: "https://www.douyin.com", description: "字节跳动旗下短视频社交平台，全民创作与分享", category: "video", tags: ["短视频", "社交"] },
  // 社交平台
  { id: 18, name: "微信", url: "https://weixin.qq.com", description: "腾讯旗下全方位的移动社交与生活服务平台", category: "social", tags: ["社交", "即时通讯"] },
  { id: 19, name: "微博", url: "https://weibo.com", description: "中国领先的社交媒体平台，实时热搜与话题讨论", category: "social", tags: ["社交", "媒体"] },
  { id: 20, name: "知乎", url: "https://www.zhihu.com", description: "中文互联网高质量的问答社区和创作者聚集平台", category: "social", tags: ["问答", "社区"] },
  { id: 21, name: "豆瓣", url: "https://www.douban.com", description: "中国领先的社区网站，涵盖电影、图书、音乐等领域", category: "social", tags: ["社区", "文化"] },
  { id: 22, name: "小红书", url: "https://www.xiaohongshu.com", description: "年轻人的生活方式平台，分享美好生活", category: "social", tags: ["社交", "种草"] },
  // 学习教育
  { id: 23, name: "中国大学MOOC", url: "https://www.icourse163.org", description: "网易与高教社联合推出的在线教育平台，名校课程免费学", category: "education", tags: ["教育", "课程"] },
  { id: 24, name: "学堂在线", url: "https://www.xuetangx.com", description: "清华大学发起的精品中文慕课平台", category: "education", tags: ["教育", "慕课"] },
  { id: 25, name: "网易公开课", url: "https://open.163.com", description: "汇集全球名校公开课资源的在线学习平台", category: "education", tags: ["教育", "公开课"] },
  { id: 26, name: "知网", url: "https://www.cnki.net", description: "中国最大的学术文献数据库，学术研究必备工具", category: "education", tags: ["学术", "论文"] },
  { id: 27, name: "百度学术", url: "https://xueshu.baidu.com", description: "百度旗下的免费学术资源搜索平台", category: "education", tags: ["学术", "搜索"] },
  // 金融理财
  { id: 28, name: "支付宝", url: "https://www.alipay.com", description: "蚂蚁集团旗下第三方支付与数字生活服务平台", category: "finance", tags: ["支付", "理财"] },
  { id: 29, name: "中国工商银行", url: "https://www.icbc.com.cn", description: "中国最大的商业银行，提供全方位金融服务", category: "finance", tags: ["银行", "金融"] },
  { id: 30, name: "中国建设银行", url: "https://www.ccb.com", description: "中国领先的大型股份制商业银行", category: "finance", tags: ["银行", "金融"] },
  { id: 31, name: "招商银行", url: "https://www.cmbchina.com", description: "中国领先的零售银行，以优质服务著称", category: "finance", tags: ["银行", "服务"] },
  { id: 32, name: "东方财富网", url: "https://www.eastmoney.com", description: "中国领先的互联网财经信息服务平台", category: "finance", tags: ["财经", "资讯"] },
  // 科技数码
  { id: 33, name: "中关村在线", url: "https://www.zol.com.cn", description: "中文第一科技门户，数码产品资讯与评测", category: "technology", tags: ["数码", "评测"] },
  { id: 34, name: "太平洋电脑网", url: "https://www.pconline.com.cn", description: "专业的IT产品导购与评测平台", category: "technology", tags: ["电脑", "数码"] },
  { id: 35, name: "IT之家", url: "https://www.ithome.com", description: "前沿科技媒体，实时报道全球IT资讯", category: "technology", tags: ["科技", "资讯"] },
  { id: 36, name: "36氪", url: "https://36kr.com", description: "中国领先的科技新媒体，报道最新的互联网新闻", category: "technology", tags: ["科技", "创业"] },
  { id: 37, name: "虎嗅", url: "https://www.huxiu.com", description: "聚合优质创新信息与人群的科技商业新媒体", category: "technology", tags: ["科技", "商业"] },
  // 旅游出行
  { id: 38, name: "携程旅行网", url: "https://www.ctrip.com", description: "中国领先的在线旅行服务公司，一站式旅行预订", category: "travel", tags: ["旅行", "预订"] },
  { id: 39, name: "去哪儿网", url: "https://www.qunar.com", description: "中国领先的旅游搜索引擎，比价预订一站搞定", category: "travel", tags: ["旅行", "搜索"] },
  { id: 40, name: "飞猪", url: "https://www.fliggy.com", description: "阿里巴巴旗下综合性旅游出行服务平台", category: "travel", tags: ["旅行", "预订"] },
  { id: 41, name: "12306", url: "https://www.12306.cn", description: "中国铁路客户服务中心，官方火车票预订平台", category: "travel", tags: ["火车票", "官方"] },
  { id: 42, name: "滴滴出行", url: "https://www.didiglobal.com", description: "中国领先的一站式移动出行平台", category: "travel", tags: ["出行", "打车"] },
  // 生活服务
  { id: 43, name: "美团", url: "https://www.meituan.com", description: "中国领先的生活服务电子商务平台，吃喝玩乐全都有", category: "life", tags: ["生活", "团购"] },
  { id: 44, name: "大众点评", url: "https://www.dianping.com", description: "中国领先的本地生活信息及交易平台", category: "life", tags: ["生活", "点评"] },
  { id: 45, name: "58同城", url: "https://www.58.com", description: "中国最大的分类信息服务平台", category: "life", tags: ["分类", "生活"] },
  { id: 46, name: "饿了么", url: "https://www.ele.me", description: "中国领先的在线外卖订餐平台", category: "life", tags: ["外卖", "配送"] },
  { id: 47, name: "顺丰速运", url: "https://www.sf-express.com", description: "中国领先的快递物流综合服务商", category: "life", tags: ["快递", "物流"] },
  // 政府组织
  { id: 48, name: "中国政府网", url: "https://www.gov.cn", description: "中华人民共和国中央人民政府门户网站", category: "government", tags: ["政府", "官方"] },
  { id: 49, name: "中华人民共和国公安部", url: "https://www.mps.gov.cn", description: "公安部官方网站，发布公安工作动态与政策法规", category: "government", tags: ["政府", "公安"] },
  { id: 50, name: "中华人民共和国教育部", url: "https://www.moe.gov.cn", description: "教育部官方网站，教育政策与信息发布", category: "government", tags: ["政府", "教育"] },
  { id: 51, name: "国家税务总局", url: "https://www.chinatax.gov.cn", description: "国家税务总局官方网站，税务政策权威发布", category: "government", tags: ["政府", "税务"] },
];

export const articles = [
  {
    id: 1,
    slug: "identify-fake-websites",
    title: "如何识别假冒网站？正品蓝导航为您支招",
    description: "在互联网时代，假冒网站层出不穷。本文为您详细介绍识别假冒网站的实用方法，帮助您安全上网。",
    content: `## 假冒网站的危害

在互联网高速发展的今天，网络诈骗手段层出不穷，其中假冒网站是最常见的诈骗形式之一。不法分子通过仿冒正规网站的页面设计、域名和内容，诱导用户输入个人信息、账号密码等敏感数据，造成严重的经济损失和隐私泄露。

## 如何快速识别假冒网站

### 1. 仔细核对网址（URL）

正规网站的网址通常简洁规范，假冒网站则可能在域名中使用混淆字符。例如：
- 将字母"o"替换为数字"0"
- 将字母"l"替换为数字"1"
- 添加多余的前后缀

**建议：** 直接在正品蓝导航中搜索目标网站，通过我们严格审核的链接访问。

### 2. 检查网站安全证书

正规网站通常会部署SSL证书，浏览器地址栏会显示锁形图标。点击该图标可以查看证书详情，确认网站的真实身份。

### 3. 查看网站内容质量

假冒网站往往内容粗糙、错别字多、图片模糊。正规网站注重用户体验，内容经过专业编辑和审核。

### 4. 留意支付环节

在需要输入银行卡信息或进行在线支付时，务必确认支付页面的网址以"https://"开头，且域名属于正规支付平台。

## 使用正品蓝导航，远离假冒网站

正品蓝导航对每一个收录的网站都经过人工审核，确保链接真实可靠。我们的审核标准包括：
- 域名所有权验证
- 网站资质审核
- 用户口碑评价
- 安全扫描检测

选择正品蓝导航，就是选择安全、可靠的上网体验。`,
    category: "news",
    author: "正品蓝导航编辑部",
    date: "2024-08-01",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20professional%20digital%20security%20concept%20image%20showing%20a%20magnifying%20glass%20over%20a%20web%20browser%20address%20bar%2C%20warm%20lighting%2C%20clean%20minimal%20composition%2C%20cybersecurity%20theme%2C%20soft%20beige%20and%20cream%20background%2C%20editorial%20style%20photography%20with%20gentle%20shadows%2C%20professional%20and%20trustworthy%20atmosphere&width=1200&height=630&seq=article-identify-fake&orientation=landscape"
  },
  {
    id: 2,
    slug: "top-10-websites-2024",
    title: "2024年最值得收藏的十大正品网站",
    description: "正品蓝导航精心整理了2024年最值得收藏的十大网站，涵盖购物、学习、生活等各个方面，让您的上网体验更加高效。",
    content: `## 前言

在信息爆炸的时代，找到值得信赖的网站变得越来越重要。正品蓝导航编辑团队经过严格筛选，为您推荐2024年最值得收藏的十大正品网站。

## 十大推荐网站

### 1. 京东 - 购物首选

京东作为中国领先的自营电商平台，以正品保障和极速物流著称。无论是数码产品还是日常用品，京东都是您的可靠选择。

### 2. 新华网 - 权威资讯

作为国家通讯社主办的综合新闻平台，新华网提供最权威、最及时的新闻资讯。

### 3. 哔哩哔哩 - 学习娱乐两不误

B站不仅是年轻人的娱乐平台，更是知识学习的宝库，各类优质课程和纪录片应有尽有。

### 4. 知乎 - 高质量问答社区

有问题，上知乎。各领域专业人士为您答疑解惑，是拓展知识面的绝佳平台。

### 5. 中国大学MOOC - 名校课程免费学

汇集清华、北大等顶尖高校的优质课程资源，让每个人都有机会接受最好的教育。

### 6. 支付宝 - 数字生活管家

从支付、理财到生活缴费，支付宝已经成为中国人数字生活的核心平台。

### 7. 携程旅行网 - 出行好帮手

无论是机票、酒店还是旅游攻略，携程为您提供一站式旅行服务。

### 8. 美团 - 吃喝玩乐全搞定

美食外卖、酒店预订、电影票购买，美团让您的生活更加便捷。

### 9. 中关村在线 - 数码产品导购专家

购买数码产品前必看的评测平台，帮您做出最明智的选择。

### 10. 中国政府网 - 权威政务平台

了解国家政策、办理政务服务的官方入口，信息权威可靠。

## 结语

以上十大网站均已收录在正品蓝导航中，欢迎随时访问。我们将持续更新更多优质网站资源，为您打造最值得信赖的网址导航平台。`,
    category: "news",
    author: "正品蓝导航编辑部",
    date: "2024-07-15",
    readTime: "10分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20website%20icons%20arranged%20elegantly%20on%20a%20warm%20minimal%20desktop%20background%2C%20soft%20cream%20and%20beige%20tones%2C%20clean%20modern%20aesthetic%2C%20professional%20editorial%20photography%2C%20gentle%20natural%20lighting%2C%20organized%20and%20trustworthy%20visual%20style&width=1200&height=630&seq=article-top-10&orientation=landscape"
  },
  {
    id: 3,
    slug: "internet-safety-guide",
    title: "网络安全指南：保护个人信息从正品网站开始",
    description: "个人信息安全是每位网民都应重视的问题。本文为您提供实用的网络安全防护建议，从源头保护您的数据安全。",
    content: `## 个人信息安全的重要性

在大数据时代，个人信息被称为"新石油"，其价值不言而喻。一旦个人信息遭到泄露，可能面临骚扰电话、精准诈骗、身份盗用等严重后果。

## 个人信息保护的实用方法

### 1. 只访问正品官方网站

访问假冒网站是个人信息泄露的主要途径之一。使用正品蓝导航，可以确保您访问的都是经过验证的正品网站。

### 2. 设置强密码

为不同平台设置不同的复杂密码，避免使用生日、手机号等容易猜测的信息。建议使用密码管理器来管理多个密码。

### 3. 开启双重验证

对于支持双重验证的平台，务必开启此功能。即使密码泄露，也能有效阻止不法分子登录您的账号。

### 4. 谨慎授权

在使用App或网站时，仔细阅读权限请求，不要轻易授予不必要的权限。特别是通讯录、相册、位置等敏感权限。

### 5. 定期检查账号安全

定期查看各平台的登录记录和安全设置，及时发现异常登录行为。

### 6. 警惕钓鱼邮件和短信

不要点击来源不明的链接，不要轻易相信中奖、退款等诱导信息。如有疑问，通过正品蓝导航访问官方渠道核实。

## 正品蓝导航的安全承诺

正品蓝导航致力于为用户提供安全可靠的上网入口。我们的团队持续监控收录网站的安全状态，及时清理失效或存在安全隐患的链接。

保护您的信息安全，从选择正品蓝导航开始。`,
    category: "news",
    author: "正品蓝导航编辑部",
    date: "2024-06-20",
    readTime: "7分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20shield%20symbol%20with%20a%20lock%20icon%20on%20a%20warm%20cream%20background%2C%20minimal%20digital%20security%20concept%2C%20soft%20beige%20and%20warm%20white%20tones%2C%20clean%20professional%20composition%2C%20trustworthy%20and%20protective%20visual%20style%2C%20editorial%20photography%20with%20gentle%20shadows&width=1200&height=630&seq=article-safety&orientation=landscape"
  },
  {
    id: 4,
    slug: "online-shopping-fraud-prevention",
    title: "网购防骗指南：认准正品官网，远离假冒陷阱",
    description: "网购已经成为日常生活的一部分，但网购骗局也层出不穷。本文为您总结常见的网购骗局类型及防范措施。",
    content: `## 网购骗局现状

随着电子商务的蓬勃发展，网购骗局也日益多样化。据不完全统计，每年因网购诈骗造成的经济损失高达数十亿元。提高防骗意识，掌握识别技巧，是每位网购用户的必修课。

## 常见网购骗局类型

### 1. 假冒购物网站

不法分子仿冒知名电商平台，诱导用户在假网站上输入支付信息。这类网站与真网站外观几乎一模一样，极具迷惑性。

**防范建议：** 通过正品蓝导航访问各大电商平台，确保进入真正的官方网站。

### 2. 虚假促销信息

以"限时秒杀"、"超低折扣"为诱饵，诱导用户点击钓鱼链接。

**防范建议：** 对于过分低价的商品保持警惕，通过官方渠道核实活动真实性。

### 3. 虚假客服诈骗

冒充平台客服，以"退款"、"订单异常"等理由诱导用户提供银行卡信息。

**防范建议：** 正规平台不会通过电话或短信索要银行卡密码和验证码。

### 4. 刷单返利骗局

以"兼职刷单"的名义，诱导用户先垫付资金，承诺返利后失联。

**防范建议：** 任何要求先付款的兼职都应高度警惕，天上不会掉馅饼。

## 安全网购守则

1. **认准官方渠道：** 使用正品蓝导航访问各电商平台，避免搜索引擎中的广告链接
2. **核实商家资质：** 查看商家的营业执照、经营许可证等信息
3. **保留交易凭证：** 保存订单截图、聊天记录等，便于维权
4. **使用正规支付方式：** 避免直接转账给个人账户
5. **及时发现异常：** 定期检查银行账单，发现异常立即处理

正品蓝导航陪伴您安全网购每一天。`,
    category: "news",
    author: "正品蓝导航编辑部",
    date: "2024-05-10",
    readTime: "9分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20minimal%20ecommerce%20safety%20concept%20image%2C%20shopping%20cart%20with%20a%20verified%20checkmark%20badge%2C%20soft%20cream%20and%20beige%20background%2C%20clean%20professional%20composition%2C%20trustworthy%20online%20shopping%20theme%2C%20gentle%20natural%20lighting%2C%20editorial%20style&width=1200&height=630&seq=article-shopping&orientation=landscape"
  },
  {
    id: 5,
    slug: "brand-story",
    title: "正品蓝导航品牌故事：做最值得信赖的网址导航",
    description: "了解正品蓝导航的创立故事、品牌理念与发展历程，感受我们对纯净上网体验的不懈追求。",
    content: `## 我们的初心

在互联网海洋中，找到真正可靠的网站变得越来越困难。搜索引擎结果中充斥着广告和推广链接，假冒仿冒网站层出不穷。正品蓝导航正是在这样的背景下诞生的。

## 创始故事

正品蓝导航由一群热爱互联网、关注网络安全的资深从业者创立。创始人团队拥有超过十年的互联网行业经验，深刻理解用户在寻找可靠网站时的痛点。

"我们希望打造一个让用户完全信赖的导航平台，每一个链接都经过严格筛选，每一个推荐都基于真实品质。" —— 这是正品蓝导航创立的初心。

## 品牌理念

### 正品承诺

"正品"是我们的核心价值。我们承诺：
- **严格审核：** 每一个收录网站都经过人工审核
- **定期巡检：** 持续监控网站安全状态
- **用户反馈：** 建立用户举报机制，及时处理问题链接

### 纯净体验

我们坚持无广告、无弹窗、无恶意跳转的纯净浏览体验，让用户在正品蓝导航找到最纯粹的网址导航服务。

## 发展历程

- **2023年6月：** 正品蓝导航项目正式启动
- **2023年9月：** 完成首批500个权威网站收录
- **2024年1月：** 网站正式上线运营
- **2024年3月：** 日活跃用户突破10万
- **2024年6月：** 收录网站超过2000个，覆盖20个分类
- **至今：** 持续优化产品体验，做用户最信赖的导航平台

## 我们的团队

正品蓝导航拥有一支专业的运营和技术团队，包括：
- 资深内容编辑团队：负责网站筛选与审核
- 安全技术团队：确保平台安全稳定运行
- 用户体验团队：持续优化产品体验

## 未来展望

正品蓝导航将继续秉持"正品、安全、纯净"的理念，不断扩充收录网站资源，优化用户体验，成为中文互联网最值得信赖的网址导航平台。`,
    category: "news",
    author: "正品蓝导航编辑部",
    date: "2024-04-01",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20and%20professional%20brand%20story%20visual%2C%20compass%20or%20navigation%20symbol%20on%20a%20clean%20cream%20background%2C%20soft%20beige%20and%20warm%20white%20tones%2C%20trustworthy%20and%20reliable%20atmosphere%2C%20minimal%20editorial%20style%20photography%2C%20gentle%20lighting&width=1200&height=630&seq=article-brand&orientation=landscape"
  },
];